import { TFunction } from 'i18next'
import { z } from 'zod'

export const NOTE_NAME_MAX_LENGTH = 200
export const NOTE_DESCRIPTION_MAX_LENGTH = 260

export const makeNoteFormSchema = (t: TFunction<['reservations']>) =>
  z.object({
    noteBody: z
      .string()
      .trim()
      .min(1, t('reservations:timeBlocks.notesModal.form.noteBody.validation.required'))
      .max(
        NOTE_DESCRIPTION_MAX_LENGTH,
        t('reservations:timeBlocks.notesModal.form.noteBody.validation.maxLength', {
          max: NOTE_DESCRIPTION_MAX_LENGTH,
        }),
      ),
    title: z
      .string()
      .trim()
      .min(1, t('reservations:timeBlocks.notesModal.form.title.validation.required'))
      .max(
        NOTE_NAME_MAX_LENGTH,
        t('reservations:timeBlocks.notesModal.form.title.validation.maxLength', {
          max: NOTE_NAME_MAX_LENGTH,
        }),
      ),
  })

export type NoteFormData = z.infer<ReturnType<typeof makeNoteFormSchema>>

export const noteFormDefaultValues: NoteFormData = {
  noteBody: '',
  title: '',
}
